import { render, staticRenderFns } from "./Messagerie.vue?vue&type=template&id=1b4e5897&scoped=true&"
import script from "./Messagerie.vue?vue&type=script&lang=js&"
export * from "./Messagerie.vue?vue&type=script&lang=js&"
import style0 from "./Messagerie.vue?vue&type=style&index=0&id=1b4e5897&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e5897",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
